:host {
  display: block;
  width: 100%;
  height: 100%;
}


.image-blur{
  filter: blur(2px);
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -o-filter: blur(2px);
  -ms-filter: blur(2px);
}
